import dialogTitleClasses from "@mui/material/DialogTitle/dialogTitleClasses";
import { typographyResponsive } from "../../styles/utils";
export const MuiDialogContentTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: Object.assign(Object.assign({}, typographyResponsive(dt, "body1.medium")), { "&[class]": {
                    padding: `${dt.space.stack.large} ${dt.inline.large} ${dt.space.stack.xLarge3} ${dt.inline.large}`,
                    [`.${dialogTitleClasses.root} + &`]: {
                        paddingTop: 0,
                    },
                } }),
        },
    };
};
